import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiBookOpen, FiDollarSign } from "react-icons/fi";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [venue, setVenue] = useState(null);
  const [venueCapacity, setVenueCapacity] = useState<any>(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [fee, setFee] = useState<any>(0);
  const [vip, setVip] = useState(0);
  const [vvip, setVvip] = useState(0);
  const [email, setEmail] = useState(null);
  const [payLink, setPayLink] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [featured, setFeatured] = useState<any>("no");
  const [promoted, setPromoted] = useState<any>("no");
  const [classStatus, setClassStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const [expo, setExpo] = useState(0);
  const [pricing, setPricing] = useState<any[]>([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const classRoutes = "/data/class";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setVenue(null);
    setVenueCapacity(null);
    setStartDate(null);
    setEndDate(null);
    setStartTime(null);
    setEndTime(null);
    setFee(null);
    setVip(0);
    setVvip(0);
    setExpo(0);
    setEmail(null);
    setPayLink(null);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress(null);
    setFeatured(0);
    setDescription(null);
    setPricing([]);
  };

  const responses = (error: any, message: any) => {
    setError(error);
    setLoading(false);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const addOneClassHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) responses(true, "Image Required");
    else await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? (title as any).toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      venue: venue,
      venue_capacity: venueCapacity,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      fee: fee,
      vip: vip,
      vvip: vvip,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: classStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      pricing: pricing,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.CLASSES,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={classRoutes}
      eyebrow="DoSee Data • Classes"
      title="Add Class"
      subtitle={`List a class or workshop in ${entry_label || "this destination"}.`}
      icon={<FiBookOpen className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Add Class"
      onSubmit={addOneClassHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Photo of the class or instructor."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.CLASSES)}
        />
      </AddSection>

      <AddSection title="Class Details" hint="Title, venue and capacity.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="When the class is held."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate || "",
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate || "",
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="class_status"
        setStatus={setClassStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Add;
